// @format

const POLL_EVERY_MS = 3000;

let pollTimer: number | undefined;
let refreshThread: (url: string) => void = () => {};

function setChecking($button: JQuery, on: boolean, label: string) {
  $button.prop("disabled", on).toggleClass("checking", on);
  $button.find(".inbox-retrieve-label").text(label);
}

const attached = ($button: JQuery) => $.contains(document.documentElement, $button.get(0) as HTMLElement);

export function initInboxRetrieve($page: JQuery, refresh: (url: string) => void) {
  refreshThread = refresh;

  $page.off("click.inboxRetrieve").on("click.inboxRetrieve", ".inbox-retrieve", function(event) {
    event.stopPropagation();
    const $button = $(this);
    setChecking($button, true, "Checking…");

    $.ajax({
      url: String($button.data("url")),
      method: "POST",
      headers: {"X-CSRF-Token": $("meta[name='csrf-token']").attr("content") || ""},
      success: () => poll($button),
      error: () => {
        setChecking($button, false, "Check inbox");
        alert("Could not check the inbox. Please try again.");
      }
    });
  });
}

// A freshly loaded drawer renders a check that is still running as loading; carry on waiting for it.
export function resumeInboxRetrieve($page: JQuery) {
  const $button = $page.find(".inbox-drawer .inbox-retrieve.checking");
  if ($button.length) poll($button.first());
}

function poll($button: JQuery) {
  window.clearTimeout(pollTimer);
  pollTimer = window.setTimeout(() => {
    // The drawer was closed or moved to another thread; that drawer resumes its own polling.
    if (!attached($button)) return;

    $.getJSON(String($button.data("status-url")))
      .done(({state}) => {
        if (state === "running") return poll($button);
        if (state === "failed") return setChecking($button, false, "Check failed · try again");

        refreshThread(String($button.data("thread-url")));
      })
      .fail(() => poll($button));
  }, POLL_EVERY_MS);
}
